export default "__VITE_ASSET__CrTGS$zH__"